// common/components/DirectionBanner.tsx
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';

interface DirectionBannerProps {
    message: string;
}

export const DirectionBanner: React.FC<DirectionBannerProps> = ({ message }) => (
    <div className='lending-limits-direction-banner'>
        <FontAwesomeIcon
            icon={faInfoCircle}
            style={{ marginRight: '.5rem', color: 'darkblue' }}
        />
        {message}
    </div>
);
